<template>
    <section class="event-dashboard-header">
        <p class="event-dashboard-heading">
            ADMIN<span class="event-dashboard-text"> / SYSTEM EVENTS</span>
        </p>
        <h1 class="event-dashboard-title">
            System Events
        </h1>
    </section>
</template>

<script setup lang="ts">
</script>

<style lang="scss" src="./style.scss">
</style>